module.exports = __webpack_public_path__ + "img/serednie.2b3329e6.jpg";